import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { BaseComponent } from 'src/app/system-common/base/base.component';
import { SettingService } from 'src/app/system-common/services/setting.service';
import { AgentService } from '../services/agent.service';

@Component({
  selector: '',
  template: '',
})
export class AgentReviewApplicationHandler extends BaseComponent<AgentService> implements OnChanges, OnInit {
  downloadPDFDetails: { button_id: any; link: any; ref_id: any; refNum: string };
  constructor(agentService: AgentService, public settingService: SettingService) {
    super(agentService);
  }
  uiImageModelList = [];
  ngOnInit() {}

  ngOnChanges() {}

  getFileDataType(fileName: string) {
    let ext = fileName.substring(fileName.lastIndexOf('.') + 1, fileName.length);
    let fileDataType = this.service.getValueFromLookup('FILEDATATYPE', ext);
    return fileDataType;
  }
  isPrimitive(value: any, key?): boolean {
    const excludedKeys = ['id', 'guid', 'status', 'objName', 'versionID', 'systemUpdatedDt', 'systemCreatedDt'];
    return (
      value !== null &&
      value != '' &&
      (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') &&
      !excludedKeys.includes(key)
    );
  }

  CheckValidValues(obj: any): boolean {
    if (!obj || typeof obj !== 'object') return false;

    const excludedKeys = ['id', 'guid', 'status', 'objName', 'versionID', 'systemUpdatedDt', 'systemCreatedDt'];

    return Object.keys(obj).some((key) => {
      const value = obj[key];
      return (
        value !== null &&
        value !== '' &&
        (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') &&
        !excludedKeys.includes(key)
      );
    });
  }
}
